import { useEffect, useState } from "react";
import { playToneIfEnabled } from "@/hooks/useSoundscape";

/**
 * First-load choreography overlay. Plays a brief darken-to-aurora reveal
 * exactly once per day per tab. Pure CSS sweep, no layout shift.
 */
export function WowOnOpen() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const today = new Date().toISOString().slice(0, 10);
    const key = "ap-wow-last";
    const last = sessionStorage.getItem(key);
    if (last === today || reduced) return;
    try { sessionStorage.setItem(key, today); } catch {}
    setShow(true);
    playToneIfEnabled("welcome");
    const t = window.setTimeout(() => setShow(false), 1600);
    return () => window.clearTimeout(t);
  }, []);

  if (!show) return null;
  return (
    <div
      aria-hidden
      className="fixed inset-0 z-[80] pointer-events-none"
      style={{ animation: "wow-fade 1600ms cubic-bezier(0.22,1,0.36,1) forwards" }}
    >
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(60% 50% at 50% 45%, hsl(var(--primary-glow) / 0.18), transparent 70%), hsl(var(--background))",
        }}
      />
    </div>
  );
}
